import { render, staticRenderFns } from "./footders.vue?vue&type=template&id=64a30ad4"
import script from "./footders.vue?vue&type=script&lang=js"
export * from "./footders.vue?vue&type=script&lang=js"
import style0 from "./footders.vue?vue&type=style&index=0&id=64a30ad4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports